var _excluded = ["children"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { Icon } from "../../../icon";
import { useTabContext } from "../useTabContext";
import { _getTitleBaseStyle } from "../Tab.styles";

var TabIcon = function TabIcon(_ref) {
  var children = _ref.children,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var _useTabContext = useTabContext(),
      isActive = _useTabContext.isActive,
      appearance = _useTabContext.appearance;

  var getTitleBaseStyles = function getTitleBaseStyles() {
    return _getTitleBaseStyle({
      isActive: isActive,
      appearance: appearance
    });
  };

  return /*#__PURE__*/React.createElement(Icon, _extends({
    _getBaseStyle: getTitleBaseStyles
  }, restProps), children);
};

TabIcon.displayName = 'TabIcon';
export { TabIcon };
export default TabIcon;